// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Axios Imports
import axios from 'axios'

// ** Import server Config
import apiLink from '@configs/serverConfig'

export const getInvestorsList = createAsyncThunk('appInvestors/getInvestorsList', async params => {
   params.page = params.page === 0 ? 0 : params.page - 1
   const response = await axios.post(`https://api.mfauto.com.ua/investor/list?env=${process.env.REACT_APP_NODE_ENV}`, {
      ...params,
      token: localStorage.getItem('token')
   })

   return {
      params,
      data: response.data.investors,
      totalPages: response.data.total_elements
   }
})
export const getInvestor = createAsyncThunk('appInvestors/getInvestor', async id => {
   const response = await axios.post(`https://api.mfauto.com.ua/investor/get?env=${process.env.REACT_APP_NODE_ENV}`, {
      investor_id: id,
      token: localStorage.getItem('token')
   })
   return response.data
})
export const addInvestor = createAsyncThunk('appInvestors/addInvestor', async data => {
   const response = await axios.post(`https://api.mfauto.com.ua/investor/add?env=${process.env.REACT_APP_NODE_ENV}`, {
      ...data,
      token: localStorage.getItem('token')
   })
   return response.data
})
export const updateInvestor = createAsyncThunk('appInvestors/updateInvestor', async data => {
   const response = await axios.post(`https://api.mfauto.com.ua/investor/update?env=${process.env.REACT_APP_NODE_ENV}`, {
      ...data,
      token: localStorage.getItem('token')
   })
   return response.data
})
export const removeInvestor = createAsyncThunk('appInvestors/removeInvestor', async id => {
   const response = await axios.post(`https://api.mfauto.com.ua/investor/remove?env=${process.env.REACT_APP_NODE_ENV}`, {
      investor_id: id,
      token: localStorage.getItem('token')
   })
   return response.data
})
export const reactivateInvestor = createAsyncThunk('appInvestors/reactivateInvestor', async id => {
   const response = await axios.post(`https://api.mfauto.com.ua/investor/reactivate?env=${process.env.REACT_APP_NODE_ENV}`, {
      investor_id: id,
      token: localStorage.getItem('token')
   })
   return response.data
})

// Media files
export const investorUploadFile = createAsyncThunk('appInvestors/investorUploadFile', async ({investor_id, type, typeOwner, data}) => {
   const response = await axios({
        method: "post",
        url: apiLink({name: 'investorUploadFile', value: investor_id}, {type, typeOwner}),
        data,
        headers: { "Content-Type": "multipart/form-data" }
      })
   return response.data
})
export const getMedia = createAsyncThunk('appInvestors/getMedia', async ({investor_id, types}) => {
   const response = await axios.post(apiLink('getFiles', {typeOwner: 'INVESTOR'}), {
      ids: [investor_id],
      types
   })
   return {files: response.data.files, investor_id}
})
export const addMedia = createAsyncThunk('appInvestors/addMedia', async ({investor_id, type, typeOwner, file}) => {
   const response = await axios({
        method: "post",
        url: apiLink({name: 'investorUploadFile', value: investor_id}, {type, typeOwner}),
        data: { file },
        headers: { "Content-Type": "multipart/form-data" }
      })
   return response.data
})
export const removeMedia = createAsyncThunk('appInvestors/removeMedia', async (id) => {
   const response = await axios.delete(apiLink({name: 'removeFile', value: id}, {typeOwner: 'INVESTOR'}))
   return {id, status: response.status}
})

// Agreements
export const getInvestorAgreements = createAsyncThunk('appInvestors/getInvestorAgreements', async params => {
   params.page = params.page === 0 ? 0 : params.page - 1
   const response = await axios.post(`https://api.mfauto.com.ua/investor/agreement-v2/list?env=${process.env.REACT_APP_NODE_ENV}`, {
      ...params,
      token: localStorage.getItem('token')
   })

   return {
      params,
      agreements: response.data.agreements,
      totalPages: response.data.total_elements
   }
})
export const addInvestorAgreement = createAsyncThunk('appInvestors/addInvestorAgreement', async data => {
   const response = await axios.post(`https://api.mfauto.com.ua/investor/agreement-v2/add?env=${process.env.REACT_APP_NODE_ENV}`, {
      ...data,
      token: localStorage.getItem('token')
   })
   return response.data
})
export const removeInvestorAgreement = createAsyncThunk('appInvestors/removeInvestorAgreement', async id => {
   const response = await axios.post(`https://api.mfauto.com.ua/investor/agreement-v2/remove?env=${process.env.REACT_APP_NODE_ENV}`, {
      agreement_id: id,
      token: localStorage.getItem('token')
   })
   return response.data
})
export const getCarsNoInvestors = createAsyncThunk('appInvestors/getCarsNoInvestors', async (data) => {   
   const response = await axios.post(`https://api.mfauto.com.ua/investor/agreement-v2/get-cars-no-investors?env=${process.env.REACT_APP_NODE_ENV}`, data)
   return response.data
})

// ** Agreements
export const getAgreement = createAsyncThunk('appInvestors/getAgreement', async (data) => {   
   const response = await axios.post(`https://api.mfauto.com.ua/investor/agreement-v2/get?env=${process.env.REACT_APP_NODE_ENV}`, {
      ...data,
      token: localStorage.getItem('token')
   })
   return response.data
})
export const editAgreement = createAsyncThunk('appInvestors/editAgreement', async (data) => {   
   const response = await axios.post(`https://api.mfauto.com.ua/investor/agreement-v2/edit?env=${process.env.REACT_APP_NODE_ENV}`, {
      ...data,
      token: localStorage.getItem('token')
   })
   return response.data
})
export const getAgreementPayments = createAsyncThunk('appInvestors/getAgreementPayments', async params => {   
   params.page = params.page === 0 ? 0 : params.page - 1
   const response = await axios.post(`https://api.mfauto.com.ua/investor/agreement-v2/payments?env=${process.env.REACT_APP_NODE_ENV}`, params)

   return {
      params,
      data: response.data.response,
      totalPages: response.data.total_elements
   }
})
export const getInvestorReportTypical = createAsyncThunk('appInvestors/getInvestorReportTypical', async (data) => {   
   const response = await axios.post(`https://api.mfauto.com.ua/investor/agreement-v2/get-car-report?env=${process.env.REACT_APP_NODE_ENV}`, {
      ...data
   })
   return response.data
})
export const getInvestorReportTypicalExcel = createAsyncThunk('appInvestors/getInvestorReportTypicalExcel', async (data) => {
   const response = await axios.post(`https://api.mfauto.com.ua/investor/agreement-v2/get-car-report-excel?env=${process.env.REACT_APP_NODE_ENV}`, {
      ...data
   })
   return response.data
})
export const getInvestorReportProfitSharingExcel = createAsyncThunk('appInvestors/getInvestorReportProfitSharingExcel', async (data) => {
   const response = await axios.post(`https://api.mfauto.com.ua/investor/agreement-v2/get-profit-sharing-report-excel?env=${process.env.REACT_APP_NODE_ENV}`, {
      ...data
   })
   return response.data
})


// ** Payments
export const addPayment = createAsyncThunk('appInvestors/addPayment', async (data) => {
   return await axios.post(apiLink('addPayment'), data)
})
export const removeRentPayment = createAsyncThunk('appInvestors/removeRentPayment', async (id) => {
   const response = await axios.delete(apiLink({name: 'removePayment', value: id}, {type: 'INVESTOR'}))
   return response.data
})

export const appInvestorsSlice = createSlice({
   name: 'appInvestors',
   initialState: {
      data: [],
      archive: [],
      total: 1,
      params: {},
      media: [],      
      selectedInvestor: null,
      selectedAgreement: null,   
      agreements: [],
      payments: []
   },
   reducers: {},
   extraReducers: builder => {
      builder      
      .addCase(getInvestorsList.fulfilled, (state, action) => {
         state.data = action.payload.data
         state.params = action.payload.params
         state.total = action.payload.totalPages
      })      
      .addCase(getAgreementPayments.fulfilled, (state, action) => {
         state.payments = action.payload.data
         state.params = action.payload.params
         state.total = action.payload.totalPages
      })
      .addCase(getInvestor.fulfilled, (state, action) => {
         state.selectedInvestor = action.payload.error !== undefined ? null : action.payload
      })
      .addCase(getAgreement.fulfilled, (state, action) => {         
         state.selectedAgreement = action.payload.error !== undefined ? null : action.payload
      })      
      .addCase(updateInvestor.fulfilled, (state, action) => {
         state.selectedInvestor = action.payload
      })      
      .addCase(getMedia.fulfilled, (state, action) => {
         const uniqueMedia = [...state.media, ...action.payload.files].reduce((accumulator, current) => {
            if (!accumulator.find((item) => item.file_id === current.file_id)) {
               accumulator.push(current)
            }
            return accumulator
         }, [])
         state.media = uniqueMedia.filter((item) => item.owner_id === action.payload.investor_id)
      })
      .addCase(removeMedia.fulfilled, (state, action) => {
         if (action.payload.status === 200) {
            state.media = state.media.filter(item => item.file_id !== action.payload.id)
         }
      })  
      .addCase(getInvestorAgreements.fulfilled, (state, action) => {
         state.agreements = action.payload.agreements
         state.params = action.payload.params
         state.total = action.payload.totalPages
      })    
   }
})

export default appInvestorsSlice.reducer
